var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.17,0A4.17,4.17,0,0,0,0,4.17v6.66A4.17,4.17,0,0,0,4.17,15h6.66A4.17,4.17,0,0,0,15,10.83V4.17A4.17,4.17,0,0,0,10.83,0Zm0,1.67h6.66a2.5,2.5,0,0,1,2.5,2.5v6.66a2.5,2.5,0,0,1-2.5,2.5H4.17a2.5,2.5,0,0,1-2.5-2.5V4.17A2.5,2.5,0,0,1,4.17,1.67Zm7.5.83a.85.85,0,0,0-.59.24.83.83,0,0,0-.25.59.85.85,0,0,0,.84.84.83.83,0,0,0,.59-.25.85.85,0,0,0,.24-.59.82.82,0,0,0-.83-.83ZM7.5,3.33A4.17,4.17,0,1,0,11.67,7.5,4.17,4.17,0,0,0,7.5,3.33ZM7.5,5A2.5,2.5,0,1,1,5,7.5,2.5,2.5,0,0,1,7.5,5Z"}));
}

Instagram.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = Instagram;

Instagram.default = Instagram;
